var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLogoYoutube = function SvgIconLogoYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5581 2.02764C19.4433 1.63573 19.2196 1.27844 18.909 0.991343C18.5985 0.704248 18.212 0.497366 17.7881 0.3913C16.236 0 9.98961 0 9.98961 0C9.98961 0 3.7429 0.0118444 2.19086 0.403144C1.76692 0.509217 1.38043 0.716109 1.06988 1.00322C0.759337 1.29033 0.535569 1.64763 0.420865 2.03956C-0.0485885 4.58886 -0.230698 8.4734 0.433755 10.9207C0.548472 11.3126 0.772244 11.6699 1.08279 11.957C1.39334 12.2441 1.77982 12.451 2.20376 12.5571C3.75579 12.9484 10.0023 12.9484 10.0023 12.9484C10.0023 12.9484 16.2488 12.9484 17.8008 12.5571C18.2247 12.451 18.6112 12.2441 18.9218 11.957C19.2324 11.6699 19.4561 11.3126 19.5709 10.9207C20.066 8.36781 20.2186 4.48572 19.5581 2.02771V2.02764Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00159 9.2494L13.1835 6.47477L8.00166 3.70013L8.00159 9.2494Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLogoYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-logo-youtube.a4f56242.svg";
export { ForwardRef as ReactComponent };